export default function ComparisonSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2 relative min-h-[400px] lg:min-h-[560px]">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20three-panel%20comparison%20concept%20with%20distinct%20premium%20product%20displays%20on%20light%20cream%20surface%20soft%20natural%20studio%20lighting%20editorial%20style%20professional%20product%20photography%20showing%20subtle%20quality%20differences%20warm%20neutral%20tones%20clean%20balanced%20composition%20elegant%20visual%20hierarchy&width=900&height=700&seq=compare-cssbuy-v3-2026&orientation=landscape"
            alt="CSSBuy Spreadsheet Comparison"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-primary-900/20"></div>
          <div className="absolute top-8 left-8">
            <span className="inline-block bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium px-4 py-1.5 rounded-full">
              Análise 2026
            </span>
          </div>
          <div className="absolute bottom-8 left-8">
            <h2 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl text-background-50 leading-[1.05] tracking-tight">
              CSSBuy<br />versus<br />Concorrência
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex items-center py-14 md:py-20">
          <div className="w-full px-6 md:px-12 lg:px-14 max-w-xl mx-auto">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-foreground-950 leading-tight">
              Qual agente<br />vale mais a pena?
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              Comparamos os principais agentes de compras para ajudar na sua decisão.
              O CSSBuy Spreadsheet oferece a melhor combinação de segurança, preço e variedade.
            </p>

            <div className="mt-8 overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 pr-4 font-semibold text-foreground-700 whitespace-nowrap">Plataforma</th>
                    <th className="text-center py-3 px-3 font-semibold text-foreground-700 whitespace-nowrap">Segurança</th>
                    <th className="text-center py-3 px-3 font-semibold text-foreground-700 whitespace-nowrap">Preço</th>
                    <th className="text-center py-3 pl-3 font-semibold text-foreground-700 whitespace-nowrap">Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="py-3.5 pr-4 font-semibold text-foreground-900 whitespace-nowrap">CSSBuy</td>
                    <td className="text-center py-3.5 px-3 text-accent-600 whitespace-nowrap">★★★★★</td>
                    <td className="text-center py-3.5 px-3 text-accent-600 whitespace-nowrap">★★★★★</td>
                    <td className="text-center py-3.5 pl-3 font-semibold text-accent-600 whitespace-nowrap">Sim</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="py-3.5 pr-4 font-semibold text-foreground-700 whitespace-nowrap">Pandabuy</td>
                    <td className="text-center py-3.5 px-3 text-foreground-500 whitespace-nowrap">★★★</td>
                    <td className="text-center py-3.5 px-3 text-foreground-500 whitespace-nowrap">★★★</td>
                    <td className="text-center py-3.5 pl-3 text-foreground-500 whitespace-nowrap">Parcial</td>
                  </tr>
                  <tr>
                    <td className="py-3.5 pr-4 font-semibold text-foreground-700 whitespace-nowrap">Superbuy</td>
                    <td className="text-center py-3.5 px-3 text-foreground-500 whitespace-nowrap">★★★★</td>
                    <td className="text-center py-3.5 px-3 text-foreground-500 whitespace-nowrap">★★★★</td>
                    <td className="text-center py-3.5 pl-3 text-foreground-500 whitespace-nowrap">Limitado</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Ver comparação completa
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}